const statuses = [
  { status: "1", color: "bg-blue-500", text: "В обробці" },
  { status: "2", color: "bg-green-500", text: "Відправлено" },
  { status: "3", color: "bg-red-500", text: "Відмовлено" },
  { status: "4", color: "bg-gray-500", text: "Отримано" },
];
export default statuses;
